import React from 'react';
import PropTypes from 'prop-types';
//import isEqual from 'lodash/isEqual';
//import cloneDeep from 'lodash/cloneDeep';
const withList = WrappedComponent=>{
  class Comp extends React.Component{
    constructor(props){
      super(props);
      this.state={load:0};
      //this.masterData = cloneDeep(this.props.masterData||{});
    }
    componentDidMount(){
    }
    async shouldComponentUpdate(nextProps,nextState){
      if(nextState.load!==this.state.load){
        return true;
      }
      if(nextProps.model!=this.props.model){
        console.log("Model changed, rerender withList",nextProps.model);
        this.listModel =null;
        return true;
      }
      if(nextProps.valueField!=this.props.valueField){
        console.log("value field changed, rerender withList",nextProps.model);
        return true;
      }

      /*if(!isEqual(this.masterData,(nextProps.masterData||{}))){
        this.masterData = cloneDeep(nextProps.masterData||{});
        console.log("masterData changed, rerender withlist",nextProps.model);
        return true;
      }

      if(!isEqual(nextProps.value,this.props.value)){
        console.log("value changed, rerender withList",nextProps.model);
        return true;
      }*/

      /*let oldCondition = this.props.condition;
      let newCondition = nextProps.condition;

      if(oldCondition && oldCondition.then){
        oldCondition = await oldCondition;
      }
      if(newCondition && newCondition.then){
        newCondition = await newCondition;
      }
      if(!isEqual(oldCondition,newCondition)){
        console.log("condition changed, rerender withList",nextProps.model,"old",oldCondition,"new",newCondition);
        return true;
      }*/
      return false;
    }
    async getListModel(){
      let model = this.props.model;
      if(!model) return null;
      await new Promise( (resolve)=>{
        (async ()=>{
          if(!this.listModel){
            const {default:InputBase} = await import(
              /* webpackPrefetch: true */
              /* webpackChunkName: "InputBase" */
              "./InputBase"
            );
            this.setState({
              InputBase:<InputBase ref={ref=>this.listModel = ref} noRender code={model}/>,
              load:this.state.load+1
            },()=>{
              resolve()
            })
          }else{
            resolve()
          }
        })();
      })
      return this.listModel;
    }
    render(){
      const {forwardedRef, ...rest} = this.props;
      return (
        <>
          <WrappedComponent  getListModel={this.getListModel.bind(this)} ref={forwardedRef} {...rest}/>
          {this.state.InputBase}
        </>
      )
    }
  }
  Comp.propTypes={
    model:PropTypes.string,
    valueField:PropTypes.string,
    value:PropTypes.any,
    condition:PropTypes.any,
    forwardedRef:PropTypes.any,
    mediaQueryMatches:PropTypes.bool,
  }
  return Comp
}
export default withList;
